import TrailConditionsActionTaken from '../enums/TrailConditionsActionTaken';
import TrailConditionsCTAType from '../enums/TrailConditionsCTAType';
import TrailConditionsScreen from '../enums/TrailConditionsScreen';
import { getAmplitudeInstance } from '../amplitudeHelpers';

type logTrailDetailsConditionsCTATappedParams = {
  action_taken?: TrailConditionsActionTaken;
  conditions_screen?: TrailConditionsScreen;
  cta_index?: number;
  cta_type: TrailConditionsCTAType;
  is_peak?: boolean;
  trail_id: number;
};

/**
 * User taps on 'weather map' CTA or ground conditions row (when applicable)
 * @param params - Attributes to log with the amplitude event
 * @param params.action_taken - Whether the user taps the cta or the cta card
 * @param params.conditions_screen - The screen that the user tapped the CTA on in the free version
 * @param params.cta_index - The index placement of the CTA card. e.g., 3 means it is the third CTA card displayed
 * @param params.cta_type - The CTA type displayed on the tapped conditions card
 * @param params.is_peak - whether the user tapped the trail details conditions CTA as part of the non-Peak ad or as part of the paid experience
 * @param params.trail_id - The trail id of the associated trail details page.
 */
const logTrailDetailsConditionsCTATapped = (
  { action_taken, conditions_screen, cta_index, cta_type, is_peak, trail_id }: logTrailDetailsConditionsCTATappedParams,
  callback?: () => void
) => {
  getAmplitudeInstance().logEvent(
    'trail details conditions cta tapped',
    {
      'action taken': action_taken,
      'conditions screen': conditions_screen,
      'cta index': cta_index,
      'cta type': cta_type,
      'is peak': is_peak,
      'trail id': trail_id
    },
    callback
  );
};

export default logTrailDetailsConditionsCTATapped;
